var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[(_vm.icon)?_c('i',{class:_vm.iconClass}):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }